export const saturdayUppercase = "beEA3b";
export default {saturdayUppercase};